import { dataQuestionCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconQuestionCircle = /*#__PURE__*/createIcon(dataQuestionCircle)
export default IconQuestionCircle
